import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export const requestEarningsCalculation = createAction(`${actionKey}/REQUEST_CALCULATION`, (dollarPrice, productType)=>({
        dollarPrice,
        productType
    }));
export const requestEarningsCalculationSuccess = createAction(`${actionKey}/REQUEST_CALCULATION_SUCCESS`, (result)=>result);
export const requestEarningsCalculationError = createAction(`${actionKey}/REQUEST_CALCULATION_ERROR`, (error)=>error);
